﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("GenerateUuid", function () {
    return function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var HEX_RADIX = 16;
        var BITMASK_0011 = 0x3;
        var BITMASK_1000 = 0x8;

        /* eslint-disable no-bitwise */
        var r = (Math.random() * HEX_RADIX) | 0,
          v = c === "x" ? r : (r & BITMASK_0011) | BITMASK_1000;
        /* eslint-enable no-bitwise */

        return v.toString(HEX_RADIX);
      });
    };
  });
})(window.angular);
